<div class="page-header">
  <div class="page-container">
    <div class="page-header__content">
      <div class="page-header__info">
        <h2 class="page-header__title">{{ "needs" | translate }}</h2>
        <span class="page-header__subtitle">{{
          "needsSubtitle" | translate
        }}</span>
      </div>

      <div class="page-header__actions">
        <button nz-button [nzType]="'primary'" (click)="new()">
          {{ "newNeed" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="page-container">
  <div class="page-content">
    <form (submit)="searchNeeds()">
      <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
        <input
          type="text"
          nz-input
          [formControl]="searchQueryControl"
          [placeholder]="'searchNeeds' | translate"
        />
      </nz-input-group>
      <ng-template #suffixIconButton>
        <button nz-button nzType="primary" nzSearch>
          <i class="far fa-search"></i>
        </button>
      </ng-template>
    </form>

    <nz-table
      class="mt-2"
      #basicTable
      [nzData]="data"
      [nzLoading]="isLoading"
      [nzFrontPagination]="false"
      [nzTotal]="tableData.total"
      [nzPageSize]="tableData.pageSize"
      [nzPageIndex]="tableData.page"
      (nzQueryParams)="tableParamsChanged($event)"
    >
      <thead>
        <tr>
          <!-- <th nzWidth="50px">ID</th> -->
          <th>Porodica</th>
          <th>Naziv</th>
          <th>Opis</th>
          <th>Datum</th>
          <th>Active</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data">
          <!-- <td>{{ data.id }}</td> -->
         
          <td>
            <span
              nz-typography
              [nzEllipsis]="true"
              [nzExpandable]="true"
              [nzEllipsisRows]="2"
    
              >{{ data.family.representative }}</span
            >
          </td>

          <td>
            <span
              nz-typography
              [nzEllipsis]="true"
              [nzExpandable]="true"
              [nzEllipsisRows]="2"
          
              >{{ data.title }}</span
            >
          </td>
          <td>
            <span
              nz-typography
              [nzEllipsis]="true"
              [nzExpandable]="true"
              [nzEllipsisRows]="2"
       
              >{{ data.description }}</span
            >
          </td>

          <td>
            <span
              nz-typography
              [nzEllipsis]="true"
              [nzExpandable]="true"
              [nzEllipsisRows]="2"
          
              >{{ data.date | date }}</span
            >
          </td>

          <td>{{ data.active ? 'DA' : 'NE' }}</td>

          <td class="text-right">
            <button nz-button nzSize="small" (click)="edit(data.id)">
              <i class="far fa-pen"></i>
            </button>

            <button
              nz-button
              nzSize="small"
              class="ml-2"
              (click)="delete(data.id)"
            >
              <i class="far fa-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
